import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

const gridSx = {
  position: "relative",
  width: "100%",
  minHeight: "1px",
  paddingRight: "15px",
  paddingLeft: "15px",
  flexBasis: "auto"
};

export default function GridItem(props) {
  const { children, className, ...rest } = props;
  return (
    <Grid item {...rest} sx={gridSx} className={className}>
      {children}
    </Grid>
  );
}

GridItem.defaultProps = {
  className: ""
};

GridItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
